module.exports = __webpack_public_path__ + "img/style_5_en.6e43833f.jpeg";